/**
 * @fileOverview teamview.component.ts - view teams of current user , join and leave team
 * @author
 */
var TeamViewController = (function () {
    function TeamViewController($scope, socket, $state, env, $mdDialog, Dialog) {
        var _this = this;
        this.$scope = $scope;
        this.socket = socket;
        this.$state = $state;
        this.env = env;
        this.$mdDialog = $mdDialog;
        this.Dialog = Dialog;
        this.ownTeam = [];
        this.teamsAreLoaded = true;
        this.socket.forward('teamView.getTeams', this.$scope);
        this.$scope.$on('socket:teamView.getTeams', function (event, data) {
            if (data.id === 'getTeams') {
                console.info('Teams loaded =>  ', data);
                _this.allTeams = new Array();
                _this.myTeams = data.personsTeams;
                for (var _i = 0, _a = data.allTeams; _i < _a.length; _i++) {
                    var team = _a[_i];
                    if (!_this.myTeams.includes(team)) {
                        _this.allTeams.push(team);
                    }
                }
                _this.teamsAreLoaded = false;
            }
            else {
                console.error("Missing $id on Socket !");
            }
        });
        this.socket.forward('teamView.getTeamMembers', this.$scope);
        this.$scope.$on('socket:teamView.getTeamMembers', function (event, data) {
            _this.members = data.members;
            var results = {
                members: data.members,
                name: data.team
            };
            _this.Dialog.openDialog(event, results, TeamViewController, 'dialog.html', '');
        });
    }
    TeamViewController.prototype.$onInit = function () {
        console.info('Emitting socket: getTeams');
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getTeams',
                script: '/teamview/teamview',
                userId: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    TeamViewController.prototype.createTeam = function () {
        if (this.teamName !== '') {
            console.info('Emitting socket CreateTeam');
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'createTeam',
                    script: '/teamview/teamview',
                    teamName: this.teamName,
                    userId: this.env.user.email,
                    type: 'create',
                    token: this.env.user.token
                }
            });
            this.teamName = '';
        }
    };
    TeamViewController.prototype.leave = function (team, ev) {
        var _this = this;
        var teamName = team;
        var confirmDialog = this.$mdDialog.confirm()
            .title('Leaving a team...')
            .textContent("Are you sure you want to leave " + teamName + " team?")
            .targetEvent(ev)
            .ok('Yes')
            .cancel('No');
        this.$mdDialog.show(confirmDialog).then(function () {
            console.log('Yes pressed');
            console.log('Emitting socket LeaveTeam');
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'leaveTeam',
                    script: '/teamview/teamview',
                    teamName: teamName,
                    userId: _this.env.user.email,
                    token: _this.env.user.token
                }
            });
        }, function () {
            console.log('No pressed');
        });
    };
    TeamViewController.prototype.join = function (team, ev) {
        var _this = this;
        var teamName = team;
        var confirmDialog = this.$mdDialog.confirm()
            .title('Joining a team...')
            .textContent("Are you sure you want to join " + teamName + " team?")
            .targetEvent(ev)
            .ok('Yes')
            .cancel('No');
        this.$mdDialog.show(confirmDialog).then(function () {
            console.log('Yes pressed');
            console.log('Emitting socket JoinTeam');
            _this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'createTeam',
                    script: '/teamview/teamview',
                    teamName: teamName,
                    userId: _this.env.user.email,
                    type: 'join',
                    token: _this.env.user.token
                }
            });
        }, function () {
            console.log('No pressed');
        });
    };
    TeamViewController.prototype.viewMembers = function (team, ev) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getTeamMembers',
                script: '/teamview/teamview',
                teamName: team,
                token: this.env.user.token
            }
        });
    };
    TeamViewController.$inject = ['$scope', 'socket', '$state', 'env', '$mdDialog', 'Dialog'];
    return TeamViewController;
}());
var TeamViewComponent = (function () {
    function TeamViewComponent() {
        this.templateUrl = 'team.html';
        this.controllerAs = 'vm';
        this.controller = TeamViewController;
    }
    return TeamViewComponent;
}());
angular
    .module('application')
    .component('teamView', new TeamViewComponent());

//# sourceMappingURL=teamview.component.js.map
